import { Navigate, useParams } from "react-router-dom";
import { useSiteSettings } from "@/hooks/use-site-settings";

// Theme browsing can be switched off in Admin; its pages then send readers to /explore.
export function ThemeGate({ children }) {
  const { facet } = useParams();
  const { settings, loading } = useSiteSettings();
  if (facet !== "themes") return children;
  if (loading) return null;
  return settings.explore_themes ? children : <Navigate to="/explore" replace />;
}
